import { useEffect, useState } from 'react';
import SalesDrawer from '../../../../component/SalesDrawer';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchInvoiceDetails } from '../../../../services/invoices';
import { fetchPaymentReceivedDetails } from '../../../../services/payments_received';
import PageLoader from '../../../../component/PageLoader';
import call from '../../../../assets/image/phone-call.svg';
import email from '../../../../assets/image/email.svg';
import arrowDown from '../../../../assets/image/arrow_down_dark.svg';
import arrowUp from '../../../../assets/image/arrow_up_dark.svg';
import './customSalesDrawer.scss';
import { getDate } from '../../../../utils/dateUtils';

const CustomSalesDrawer = ({ isOpen, onClose, type, id }) => {
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [details, setDetails] = useState({});
	const [isLoading, setLoading] = useState(false);
	const [isProductShow, setIsProductShow] = useState(true);
	const [isDetailShow, setIsDetailShow] = useState(true);
	const viewMore = () => {
		if (type === 'Invoice') {
			navigate(`/user/${suburl}/invoices-details/${id}`);
		} else if (type === 'Payment Received') {
			navigate(`/user/${suburl}/payments-received-details/${id}`);
		}
	};
	async function getDrawerDetails() {
		try {
			setLoading(true);
			if (type === 'Invoice') {
				const body = {
					ids: [id],
				};
				var { invoice } = await fetchInvoiceDetails(body);
				setDetails(invoice);
			} else if (type === 'Payment Received') {
				const body = {
					ids: [id],
				};
				var { payment_receive } = await fetchPaymentReceivedDetails(body);
				setDetails(payment_receive);
			}
		} catch (e) {
			toast.error(e.message || 'Somenthing went wrong!');
		} finally {
			setLoading(false);
		}
	}
	useEffect(() => {
		if (id) {
			getDrawerDetails();
		}
	}, [id]);
	return (
		<SalesDrawer
			isOpen={isOpen}
			onClose={onClose}
			viewMore={viewMore}
			title={`${type} Details`}
		>
			<br />
			{isLoading ? (
				<PageLoader />
			) : (
				<div>
					<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
						<div
							style={{ fontSize: '20px', fontWeight: '600', color: '#000', textAlign: 'center' }}
						>
							{details?.customer?.name}
						</div>
						<div
							style={{
								padding: '10px 50px',
								fontSize: '14px',
								fontWeight: '400',
								color: '#000',
								textAlign: 'center',
							}}
						>
							{`${details?.customer?.street1}, ${details?.customer?.city?.name || 'N/A'}`}
							<br />
							<span>{`${details?.customer?.state?.name || 'N/A'},${details?.customer?.country?.name || 'N/A'}-${details?.customer?.zipcode}`}</span>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: details?.customer?.email.length > 22 ? 'column' : 'row',
							padding: '20px 0px',
						}}
					>
						<div
							className="clickableButton"
							style={{
								width: details?.customer?.email.length > 22 ? '100%' : '49%',
								marginBottom: details?.customer?.email.length > 22 ? '10px' : '0px',
							}}
						>
							<img
								src={call}
								alt=""
								style={{ width: '14px', cursor: 'pointer' }}
								onClick={() => {}}
							/>
							<span style={{ marginLeft: '5px' }}>{details?.customer?.mobile}</span>
						</div>
						<div
							className="clickableButton"
							style={{ width: details?.customer?.email.length > 22 ? '100%' : '49%' }}
						>
							<img
								src={email}
								alt=""
								style={{ width: '14px', cursor: 'pointer' }}
								onClick={() => {}}
							/>
							<span style={{ marginLeft: '5px' }}>{details?.customer?.email}</span>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: 'row',
							padding: '10px 0px',
						}}
					>
						{type === 'Invoice' && (
							<div className="AmountsBox">
								<div
									style={{
										fontSize: '16px',
										fontWeight: '600',
										color: '#000',
										textAlign: 'center',
									}}
								>
									{'Total Amount'}
								</div>
								<span style={{ marginLeft: '5px' }}>
									{`INR ${Number(details?.total_amount).toFixed(2)}/-`}
								</span>
							</div>
						)}
						<div
							className="AmountsBox"
							style={{ width: type === 'Invoice' ? '49%' : '98%' }}
						>
							<div
								style={{ fontSize: '16px', fontWeight: '600', color: '#000', textAlign: 'center' }}
							>
								{type === 'Invoice' ? 'Balance Due' : 'Amount Received'}
							</div>
							<span style={{ marginLeft: '5px' }}>
								{type === 'Invoice'
									? `INR ${Number(details?.due_amount).toFixed(2)}/-`
									: `INR ${Number(details?.used_payment_amount)}/-`}
							</span>
						</div>
					</div>
					<div
						className="invoiceBox"
						style={{ paddingBottom: isDetailShow ? '10px' : '0px' }}
					>
						<div
							className="d-flex justify-content-between"
							style={{
								backgroundColor: '#DADDEC',
								padding: '5px 10px',
								borderRadius: '4px 4px 0px 0px',
								cursor: 'pointer',
							}}
							onClick={() => setIsDetailShow(!isDetailShow)}
						>
							<div
								style={{
									fontSize: '15px',
									fontWeight: '600',
								}}
							>
								{type === 'Invoice' ? 'Invoice Details' : 'Payment Details'}
							</div>
							<img
								src={`${isDetailShow ? arrowUp : arrowDown}`}
								style={{
									cursor: 'pointer',
								}}
								onClick={() => setIsDetailShow(!isDetailShow)}
								alt=""
							/>
						</div>
						{isDetailShow && (
							<div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">
										{type === 'Invoice' ? 'Invoice No.' : 'Payment #'}
									</div>
									<div className="rowInvoiceData">
										{type === 'Invoice' ? details?.invoice_number : details?.payment_receive_number}
									</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">
										{type === 'Invoice' ? 'Invoice Date' : 'Payment Date'}
									</div>
									<div className="rowInvoiceData">{getDate(details?.date)}</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">
										{type === 'Invoice' ? 'Due Date' : 'Payment Mode'}
									</div>
									<div className="rowInvoiceData">
										{type === 'Invoice'
											? getDate(details?.due_date)
											: details?.payment_mode?.payment_method_name}
									</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">
										{type === 'Invoice' ? 'Credit Days' : 'Reference No.'}
									</div>
									<div className="rowInvoiceData">
										{type === 'Invoice' ? details?.customer?.credit_days : details?.notes}
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="invoiceBox">
						<div
							className="d-flex justify-content-between"
							style={{
								backgroundColor: '#DADDEC',
								padding: '5px 10px',
								borderRadius: '4px 4px 0px 0px',
								cursor: 'pointer',
							}}
							onClick={() => setIsProductShow(!isProductShow)}
						>
							<div
								style={{
									fontSize: '15px',
									fontWeight: '600',
								}}
							>
								{type === 'Invoice' ? 'Product Details' : 'Payment For'}
							</div>
							<img
								src={`${isProductShow ? arrowUp : arrowDown}`}
								style={{
									cursor: 'pointer',
								}}
								onClick={() => setIsProductShow(!isProductShow)}
								alt=""
							/>
						</div>
						{isProductShow && (
							<table
								style={{
									width: '100%',
									border: '0px',
									borderCollapse: 'collapse',
									textAlign: 'left',
								}}
							>
								<thead>
									{type === 'Invoice' ? (
										<tr style={{ fontWeight: 'bold', color: '#000' }}>
											<th
												style={{
													padding: '5px',
													fontSize: '15px',
													fontWeight: '500',
													textAlign: 'left',
													backgroundColor: '#EEEFF3',
												}}
											>
												Item Name
											</th>
											<th
												style={{
													padding: '5px',
													fontSize: '15px',
													fontWeight: '500',
													textAlign: 'left',
													backgroundColor: '#EEEFF3',
												}}
											>
												Quantity
											</th>
											<th
												style={{
													padding: '5px',
													fontSize: '15px',
													fontWeight: '500',
													textAlign: 'left',
													backgroundColor: '#EEEFF3',
												}}
											>
												Rate
											</th>
										</tr>
									) : (
										<tr style={{ backgroundColor: '#EEEFF3', fontWeight: 'bold', color: '#000' }}>
											<th
												style={{
													padding: '5px',
													fontSize: '15px',
													fontWeight: '500',
													textAlign: 'left',
													backgroundColor: '#EEEFF3',
												}}
											>
												Invoice No.
											</th>
											<th
												style={{
													padding: '5px',
													fontSize: '15px',
													fontWeight: '500',
													textAlign: 'left',
													backgroundColor: '#EEEFF3',
												}}
											>
												Invoice Date
											</th>
											<th
												style={{
													padding: '8px',
													fontSize: '15px',
													fontWeight: '500',
													textAlign: 'left',
													backgroundColor: '#EEEFF3',
												}}
											>
												Invoice Amt.
											</th>
											<th
												style={{
													padding: '5px',
													fontSize: '15px',
													fontWeight: '500',
													textAlign: 'left',
													backgroundColor: '#EEEFF3',
												}}
											>
												Payment Amt.
											</th>
										</tr>
									)}
								</thead>
								{type === 'Invoice' ? (
									<tbody>
										{details?.invoice_products?.map((pb) => (
											<tr>
												<td
													style={{
														padding: '5px',
														textAlign: 'left',
														color: '#000',
														cursor: 'pointer',
														fontSize: '14px',
														fontWeight: '400',
														backgroundColor: '#F6F6F9',
													}}
												>
													{pb?.product?.product_name}
												</td>
												<td
													style={{
														padding: '5px',
														textAlign: 'left',
														fontSize: '14px',
														fontWeight: '400',
														color: '#000',
														backgroundColor: '#F6F6F9',
													}}
												>
													{`${pb?.quantity} ${pb?.product?.unit?.key}`}
												</td>
												<td
													style={{
														padding: '5px',
														textAlign: 'left',
														fontSize: '14px',
														fontWeight: '400',
														color: '#000',
														backgroundColor: '#F6F6F9',
													}}
												>
													{Number(pb?.amount).toFixed(2)}
												</td>
											</tr>
										))}
									</tbody>
								) : (
									<tbody>
										{details?.sales_payment_receives_invoices?.map((pb) => (
											<tr>
												<td
													style={{
														padding: '5px',
														textAlign: 'left',
														fontSize: '14px',
														fontWeight: '400',
														color: '#3B58FF',
														cursor: 'pointer',
														backgroundColor: '#F6F6F9',
													}}
													onClick={() =>
														navigate(`/user/${suburl}/invoices-details/${pb?.invoice_id}`)
													}
												>
													{pb?.invoice?.invoice_number}
												</td>
												<td
													style={{
														padding: '5px',
														textAlign: 'left',
														fontSize: '14px',
														fontWeight: '400',
														color: '#000',
														backgroundColor: '#F6F6F9',
													}}
												>
													{getDate(pb?.invoice?.date)}
												</td>
												<td
													style={{
														padding: '5px',
														textAlign: 'left',
														fontSize: '14px',
														fontWeight: '400',
														color: '#000',
														backgroundColor: '#F6F6F9',
													}}
												>
													{Number(pb?.invoice_amount).toFixed(2)}
												</td>
												<td
													style={{
														padding: '5px',
														textAlign: 'left',
														fontSize: '14px',
														fontWeight: '400',
														color: '#000',
														backgroundColor: '#F6F6F9',
													}}
												>
													{Number(pb?.invoice_payment_amount).toFixed(2)}
												</td>
											</tr>
										))}
									</tbody>
								)}
							</table>
						)}
					</div>
				</div>
			)}
		</SalesDrawer>
	);
};

export default CustomSalesDrawer;
